export default __webpack_public_path__ + "static/media/dino_showroom_220xtc.e4a400d3.jpg";